<!-- eslint-disable -->
<template>
            <!--begin::Profile 4-->
            <div class="row">
                <!--begin::Aside-->
                <div class="col-md-4" id="kt_profile_aside">
                    <!--begin::Card-->
                    <div class="card card-custom gutter-b">

                        <div v-if="load" class="card-body">

                            <div  class="text-center mb-10">
                                <b-spinner variant="primary" label="Text Centered"></b-spinner>
                            </div>

                        </div>

                        <!--begin::Body-->
                        <div v-else class="card-body">
                            <!--begin::Toolbar-->

                            <!--begin::User-->
                            <div v-if="client.account" class="d-flex align-items-center">

                                <div v-if="client.account.image" class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                                    <img :src="$urlBackEnd(client.account.image)" class="h-75" alt=""/>
                                </div>

                                <div v-else class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                                    <img src="/media/svg/avatars/032-boy-13.svg" class="h-75 align-self-end" alt=""/>
                                </div>

                                <div>
                                    <a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary">
                                        {{client.name + ' ' + client.surname}}
                                    </a>
                                    <div v-if="client.account" class="text-muted">
                                        {{client.account.name}}
                                    </div>
                                </div>
                            </div>
                            <!--end::User-->




                            <!--begin::Contact-->
                            <div class="pt-8 pb-2">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <span class="font-weight-bold mr-2">Email:</span>
                                    <a href="#" class="text-muted text-hover-primary">{{client.email}}</a>
                                </div>
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <span class="font-weight-bold mr-2">Телефон:</span>
                                    <span class="text-muted">{{client.phone}}</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <span class="font-weight-bold mr-2">Город:</span>
                                    <span class="text-muted">{{client.city}}</span>
                                </div>

                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <span class="font-weight-bold mr-2">Тип клиента:</span>
                                    <span v-if="client.client_type === 'natural_person'" class="text-muted">Физическое лицо</span>
                                    <span v-if="client.client_type === 'entity'" class="text-muted">Юридическое лицо</span>
                                </div>

                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <span class="font-weight-bold mr-2">Название организации:</span>
                                    <span class="text-muted">{{client.name_of_company}}</span>
                                </div>

                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <span class="font-weight-bold mr-2">ИНН:</span>
                                    <span class="text-muted">{{client.inn}}</span>
                                </div>

                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <span class="font-weight-bold mr-2">КПП:</span>
                                    <span class="text-muted">{{client.kpp}}</span>
                                </div>

                            </div>

                            <div class="pt-8 pb-2">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="font-weight-bold mr-2">Юридический адрес:</span>
                                </div>
                            </div>

                            <!--end::Contact-->

                            <!--begin::Contact-->
                            <div class="pb-6">
                                {{client.legal_address}}
                            </div>
                            <!--end::Contact-->


                            <div class="pt-8 pb-2">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="font-weight-bold mr-2">Почтовый адрес:</span>
                                </div>
                            </div>

                            <!--end::Contact-->

                            <!--begin::Contact-->
                            <div class="pb-6">
                                {{client.mailing_address}}
                            </div>
                            <!--end::Contact-->


                            <div class="pt-8 pb-2">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="font-weight-bold mr-2">Адрес доставки:</span>
                                </div>
                            </div>

                            <!--end::Contact-->

                            <!--begin::Contact-->
                            <div class="pb-6">
                                {{client.address}}
                            </div>
                            <!--end::Contact-->

                            <b-link @click="editClient" class="btn btn-light-success font-weight-bold py-3 px-6 mb-2 text-center btn-block">
                                Редактировать
                            </b-link>

                        </div>
                        <!--end::Body-->
                    </div>
                    <!--end::Card-->

                    <!--end::Mixed Widget 14-->
                </div>
                <!--end::Aside-->

                <!--begin::Content-->
                <div class="col-md-8">
                    <!--begin::Row-->

                    <!--begin::Advance Table Widget 8-->
                    <div class="card card-custom gutter-b">
                        <!--begin::Header-->
                        <div class="card-header border-0 py-5">
                            <h3 class="card-title align-items-start flex-column">
                                <span class="card-label font-weight-bolder text-dark">Заказы</span>
                                <span class="text-muted mt-3 font-weight-bold font-size-sm">Сумма всех заказов: {{sumAllOrders}} <i class=" icon-nm fas fa-ruble-sign"></i></span>
                            </h3>
                        </div>
                        <!--end::Header-->

                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <!--begin::Body-->
                        <div v-else class="card-body pt-0 pb-3">
                            <!--begin::Table-->
                            <div class="table-responsive">
                                <table class="table table-head-custom table-head-bg table-vertical-center table-borderless">
                                    <thead>
                                    <tr class="bg-gray-100 text-left">
                                        <th>Номер заказа</th>
                                        <th>Итого</th>
                                        <th>Вид платежа</th>
                                        <th>Статус</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="(order, i) in client.orders">
                                    <tr v-bind:key="i">
                                        <td class="pl-0">
                                            <div class="d-flex align-items-center">
                                                <div class="symbol symbol-45 symbol-light-success mr-2">
                                <span class="symbol-label">
                                    <span class="svg-icon svg-icon-2x svg-icon-success"><!--begin::Svg Icon | path:assets/media/svg/icons/Shopping/Cart3.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect x="0" y="0" width="24" height="24"/>
        <path d="M12,4.56204994 L7.76822128,9.6401844
        C7.4146572,10.0644613 6.7840925,10.1217854
         6.3598156,9.76822128 C5.9355387,9.4146572
          5.87821464,8.7840925 6.23177872,8.3598156
           L11.2317787,2.3598156 C11.6315738,1.88006147
            12.3684262,1.88006147 12.7682213,2.3598156
             L17.7682213,8.3598156 C18.1217854,8.7840925
              18.0644613,9.4146572 17.6401844,9.76822128
               C17.2159075,10.1217854 16.5853428,10.0644613
                16.2317787,9.6401844 L12,4.56204994 Z"
              fill="#000000" fill-rule="nonzero" opacity="0.3"/>
        <path d="M3.5,9 L20.5,9 C21.0522847,9 21.5,9.44771525
         21.5,10 C21.5,10.132026 21.4738562,10.2627452
          21.4230769,10.3846154 L17.7692308,19.1538462
           C17.3034221,20.271787 16.2111026,21 15,21
            L9,21 C7.78889745,21 6.6965779,20.271787
             6.23076923,19.1538462 L2.57692308,10.3846154
              C2.36450587,9.87481408 2.60558331,9.28934029
              3.11538462,9.07692308 C3.23725479,9.02614384
               3.36797398,9 3.5,9 Z M12,17 C13.1045695,17
                14,16.1045695 14,15 C14,13.8954305 13.1045695,13
                 12,13 C10.8954305,13 10,13.8954305 10,15
                  C10,16.1045695 10.8954305,17 12,17 Z" fill="#000000"/>
    </g>
</svg><!--end::Svg Icon--></span>                                </span>
                                                </div>
<!--                                                <div class="symbol symbol-50 symbol-light mr-4">-->
<!--                                                    <div class="symbol-label" style="background-image: url('/media/svg/icons/Shopping/Cart2.svg')"></div>-->
<!--                                                </div>-->
                                                <div>
                                                    <router-link :to="{ name: 'OrderDetails', params: {id: order.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"># {{order.id}}</router-link>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                {{order.payment.sum}}  <i class="text-dark icon-nm fas fa-ruble-sign"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                {{ order.payment.type}}
                                            </span>
                                            <span class="text-muted font-weight-bold">
                                                {{ order.payment.status}}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="order.status.name === 'Обработка'" class="label label-lg label-light-warning label-inline">{{order.status.name}}</span>
                                            <span v-else-if="order.status.name === 'Выполнен'" class="label label-lg label-light-success label-inline">{{order.status.name}}</span>
                                            <span v-else-if="order.status.name === 'Отменен'" class="label label-lg label-light-danger label-inline">{{order.status.name}}</span>
                                            <span v-else class="label label-lg label-light-primary label-inline">{{order.status.name}}</span>
                                        </td>
                                        <td class="pr-0 text-right">
                                            <router-link :to="{ name: 'OrderDetails', params: {id: order.id}}" class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3">
                                                <i class="fas fa-edit"></i></router-link>
                                        </td>
                                    </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                            <!--end::Table-->
                        </div>
                        <!--end::Body-->
                    </div>
                    <!--end::Advance Table Widget 8-->
                </div>
                <!--end::Content-->

                <b-modal ref="edit-client" centered hide-footer title="Редактировать профиль">
                    <div v-if="edit_client && client.account" class="d-block">

                        <b-form-group class="mb-2" label="Изображение">
                            <div v-if="edit_client.account.image" class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                                <img :src="$urlBackEnd(edit_client.account.image)" class="h-75" alt=""/>
                            </div>

                            <div v-else class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                                <img src="/media/svg/avatars/032-boy-13.svg" class="h-75 align-self-end" alt=""/>
                            </div>

                            <vue-dropzone ref="myVueDropzone"
                                          id="dropzone"
                                          :options="dropzoneOptions"
                                          :useCustomSlot=true
                                          v-on:vdropzone-success="successDrop"
                                          v-on:vdropzone-max-files-exceeded="maxDrop"
                            >
                                <div class="dropzone-custom-content">
                                    <b class="dropzone-custom-title">Выберите файл</b>
                                    <div class="subtitle">...или перетащите его сюда</div>
                                </div>
                            </vue-dropzone>

                            <b-button v-if="edit_client.account.image" @click="deleteImage" size="sm" class="mt-3" variant="danger">Удалить изображение</b-button>
                        </b-form-group>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" description="Введите Имя" label="Имя:">
                                <b-form-input v-model.trim="edit_client.name" :class="{'is-invalid': errors.name}" required></b-form-input>
                                <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" description="Введите Фамилию" label="Фамилия:">
                                <b-form-input v-model.trim="edit_client.surname" :class="{'is-invalid': errors.surname}" required></b-form-input>
                                <div v-if="errors.surname" class="invalid-feedback">{{errors.surname[0]}}</div>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" description="Введите email" label="Email:">
                                <b-form-input v-model.trim="edit_client.email" :class="{'is-invalid': errors.email}" required></b-form-input>
                                <div v-if="errors.email" class="invalid-feedback">{{errors.email[0]}}</div>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" description="Введите город" label="Город:">
                                <b-form-input v-model.trim="edit_client.city" :class="{'is-invalid': errors.city}" required></b-form-input>
                                <div v-if="errors.city" class="invalid-feedback">{{errors.city[0]}}</div>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" description="Выберите тип клиента" label="Тип клиента:">
                                <b-form-select v-model="edit_client.client_type" >
                                    <option value="natural_person">Физическое лицо</option>
                                    <option value="entity">Юридическое лицо</option>
                                </b-form-select>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" label="Название организации:">
                                <b-form-input v-model.trim="edit_client.name_of_company" :class="{'is-invalid': errors.name_of_company}" required></b-form-input>
                                <div v-if="errors.name_of_company" class="invalid-feedback">{{errors.name_of_company[0]}}</div>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" label="ИНН:">
                                <b-form-input v-model.trim="edit_client.inn" :class="{'is-invalid': errors.inn}" required></b-form-input>
                                <div v-if="errors.inn" class="invalid-feedback">{{errors.inn[0]}}</div>
                            </b-form-group>
                        </div>

                        <div class="form-group mb-2">
                            <b-form-group class="mb-2" label="КПП:">
                                <b-form-input v-model.trim="edit_client.kpp" :class="{'is-invalid': errors.kpp}" required></b-form-input>
                                <div v-if="errors.kpp" class="invalid-feedback">{{errors.kpp[0]}}</div>
                            </b-form-group>
                        </div>

                        <b-form-group class="mb-3"
                                      label="Юридический адрес:"
                        >
                            <b-form-textarea
                                    v-model.trim="edit_client.legal_address"
                                    :class="{'is-invalid': errors.legal_address}"
                            ></b-form-textarea>
                            <div v-if="errors.legal_address" class="invalid-feedback">{{errors.legal_address[0]}}</div>
                        </b-form-group>

                        <b-form-group class="mb-3"
                                      label="Почтовый адрес:"
                        >
                            <b-form-textarea
                                    v-model.trim="edit_client.mailing_address"
                                    :class="{'is-invalid': errors.mailing_address}"
                            ></b-form-textarea>
                            <div v-if="errors.mailing_address" class="invalid-feedback">{{errors.mailing_address[0]}}</div>
                        </b-form-group>


                        <b-form-group class="mb-3"
                                      description="Введите адрес доставки"
                                      label="Адрес:"
                        >
                            <b-form-textarea
                                    id="description"
                                    v-model.trim="edit_client.address"
                                    :class="{'is-invalid': errors.address}"
                            ></b-form-textarea>
                            <div v-if="errors.address" class="invalid-feedback">{{errors.address[0]}}</div>
                        </b-form-group>

                    </div>

                    <b-button ref="add_option" class="mt-3" variant="outline-primary" block @click="saveClient">Сохранить</b-button>

                </b-modal>



            </div>
            <!--end::Profile 4-->


</template>

<script>
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_CLIENT, UPDATE_CLIENT} from "../../../core/services/store/clients.module";
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    export default {
        name: "Client",
        components: {
            vueDropzone: vue2Dropzone
        },

        mounted(){

            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Все клиенты", route: "/clients" },
                { title: "Страница клиента" }
            ]);
            this.$store.dispatch(GET_CLIENT, this.$route.params.id);
        },

        computed: {
            ...mapGetters({
                client: 'gettersClient',
                load: 'getClientLoad',
                errors: 'errorsClient'
            }),


            sumAllOrders(){

                var sum = 0;

                if (this.client) {
                    if (this.client.orders.length > 0) {
                        this.client.orders.forEach(function (order) {
                            sum = Number(sum) + Number(order.payment.sum);
                        });
                    }
                }


                return sum
            }


        },

        methods:{

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            editClient(){
                this.edit_client = this.lodash.cloneDeep(this.client);
                this.$refs['edit-client'].show()
            },

            saveClient(){
                this.$store.dispatch(UPDATE_CLIENT, {'id': this.edit_client.id, "client": this.edit_client})
                    .then(() => {
                        this.$store.dispatch(GET_CLIENT, this.$route.params.id);
                        this.showAlert('Данные успешно сохранены', 'success', 'toast');
                        this.$refs['edit-client'].hide()
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();
                this.edit_client.account.image = response.original;
            },

            maxDrop (){
                this.showAlert('Не более одного файла', 'warning', 'toast');
            },

            deleteImage(){
                this.edit_client.account.image = null
            },
        },

        data(){
            return{
                edit_client: null,

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/image/user/image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 8,
                    maxFiles:50,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },
            }
        }
    }
</script>

<style scoped>

    .dropzone .dz-message {
        text-align: center;
        margin: 0;
    }

    .dropzone {
        height: 80px;
    }

</style>